import { syncMapLights } from './models';

let currentLights = {};

export function syncLights(lights) {
  currentLights = lights || {};
  syncMapLights(currentLights);
}

export function addLight(light) {
  if (!light?.id) {
    return;
  }
  currentLights = { ...currentLights, [light.id]: light };
  syncMapLights(currentLights);
}

export function deleteLight(id) {
  if (id == null) {
    return;
  }
  const next = { ...currentLights };
  delete next[id];
  currentLights = next;
  syncMapLights(currentLights);
}

export function addDefaultLights() {
  syncMapLights({});
}
